import type { AvailabilityFilters } from '@/stores/availability/availability-store';

/**
 * Map table column ID to sidebar filter section ID.
 * Column IDs that don't have a corresponding filter are not included.
 */
export const AVAILABILITY_COLUMN_ID_TO_FILTER_ID: Record<string, string> = {
  quantity: 'quantity',
  benchmark_fee: 'benchmarkFeeThreshold',
  ca: 'caStatuses',
  counterparties: 'counterparties',
};

/** Set of column IDs that have a corresponding filter. */
export const AVAILABILITY_FILTERABLE_COLUMN_IDS = new Set(Object.keys(AVAILABILITY_COLUMN_ID_TO_FILTER_ID));

/**
 * Returns column IDs that currently have an active filter.
 */
export const getActiveAvailabilityFilterColumnIds = (
  filters: AvailabilityFilters,
): string[] => {
  const active: string[] = [];

  if (filters.quantityMin !== null || filters.quantityMax !== null) active.push('quantity');
  if (filters.benchmarkFeeThreshold !== null && filters.benchmarkFeeThreshold !== 0) active.push('benchmark_fee');
  if (filters.caStatuses.length > 0) active.push('ca');
  if (filters.counterparties.length > 0) active.push('counterparties');

  return active;
};
